import { cx } from '@linaria/core';
import { mdiPin, mdiPinOutline } from '@mdi/js';
import Icon from '@mdi/react';
import "./Pin.linaria.module.css!=!./Pin?./Pin.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNLymKz6pMMSk2rS4pSswrTssvyrUqyi9JLEnVMDFNSU3XtK7lAgBXU4dtKQAAAA=="
const tiltedPin = "atm_tr_jyd4s5";
const PinIcon = (props: any) => {
  const {
    filled,
    className,
    ...other
  } = props;
  return <Icon data-testid="IconButton__PinButton" path={filled ? mdiPin : mdiPinOutline} size={1} {...other} className={cx(tiltedPin, className)} />;
};
export default PinIcon;
export { PinIcon };